import { Button, Form, Modal, Radio, message } from "antd";
import { DefaultOptionType } from "antd/es/select";
import {
  createAnnouncementApi,
  createAnnouncementCategoryApi,
  getAnnouncementCategoryApi,
} from "api/announcement";
import { ReactComponent as Close } from "assets/icons/Close.svg";
import { ReactComponent as FilePlus } from "assets/icons/FilePlus.svg";
import Editor from "components/Editor";
import HashTagInput from "components/HashTagInput";
import CsInput from "components/Input";
import SelectCmp from "components/SelectCmp";
import MainHeader from "layouts/components/Header";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { statusOptions } from "../mockData";
import * as S from "./style";
import { NoticeType } from "antd/es/message/interface";
import { uploadFileFirst } from "utils/uploadImage";
import { LoadingOutlined } from "@ant-design/icons";
import { Editor as TinyMCEEditor } from "tinymce";

const AnnouncementCreate: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formCreateType] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage({ maxCount: 2 });
  const [categories, setCategories] = useState<DefaultOptionType[]>();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [lenghtDes, setLenghDes] = useState<number>(0);

  const handleTagsChange = (newTags: string[]) => {
    // setTags(newTags);
    form.setFieldValue("hashtag", newTags);
  };

  const setTextSearch = (value: string) => {
    console.log(value);
  };
  const showMess = (type: NoticeType, mess: string) => {
    messageApi.open({
      type: type,
      content: mess,
    });
  };
  const onFinish = async (values: any) => {
    // console.log("Success:", values);
    setLoading(true);
    try {
      let resultUpload = await uploadFileFirst(values.description);
      const { data, error }: any = await createAnnouncementApi({
        // typeId: values.category,
        status: values.status,
        title: values.title,
        description: resultUpload.html,
        // description: values.description,
        // hashtag: values.hashtag,
      });
      if (error?.errorCode === "OUT_OF_RANGE") {
        form.setFields([
          {
            name: "description",
            errors: ["Please enter max 10000 characters"],
          },
        ]);
        setLoading(false);
        return;
      }
      if (data) {
        navigate("/customer-service/announcement");
      } else {
        showMess("error", "Create Failed");
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      showMess("error", "Create Failed");
      setLoading(false);
    }
  };

  const onReset = () => {
    // console.log("onReset");
    form.resetFields();
    navigate("/customer-service/announcement");
  };

  const onFill = () => {
    // console.log("onFill");

    // form.setFieldsValue({ note: "Hello world!", gender: "male" });
    // console.log("123123");
  };

  const handleChangeContent = async (
    contentHtml: string,
    editor: TinyMCEEditor
  ) => {
    const textContent = editor.getContent({ format: "text" });
    const length = textContent === "\n" ? 0 : textContent.length;
    setLenghDes(length);

    if (length === 0) {
      form.setFields([
        {
          name: "description",
          errors: ["This field is required"],
        },
      ]);
    } else if (length < 3) {
      form.setFields([
        {
          name: "description",
          errors: ["세글자 이상 입력해 주세요"],
        },
      ]);
    } else {
      form.setFieldsValue({
        description: contentHtml,
      });
    }
  };

  const handleCreateCategory = async (val: any) => {
    try {
      const { data, error }: any = await createAnnouncementCategoryApi({
        name: val.typeName,
      });
      if (error) {
        // console.log("error", error);
        showMess("error", error.message);
        setIsOpenModal(false);
        formCreateType.setFieldValue("typeName", "");
        return;
      }
      if (data) {
        // console.log("data", data);
        getAllCategory();
        showMess("success", "Create category successfully");
        setIsOpenModal(false);
        formCreateType.setFieldValue("typeName", "");
      }
    } catch (error) {
      console.error(error);
      formCreateType.setFieldValue("typeName", "");
    }
  };

  const getAllCategory = async () => {
    try {
      const { data }: any = await getAnnouncementCategoryApi();
      const formatData: DefaultOptionType[] = data.map((item: any) => {
        const newItem: DefaultOptionType = {
          label: item.name,
          value: Number(item.id),
        };
        return newItem;
      });
      setCategories(formatData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategory();
    form.setFieldValue("hashtag", ["tag 1", "tag 2"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <S.Wrapper>
      {contextHolder}
      <MainHeader
        backLink="/customer-service/announcement"
        title="Announcement"
      />
      <Form
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        className="form-content"
        form={form}
        initialValues={{ status: "SHOWING" }}
      >
        <S.Block>
          <Form.Item>
            {/* <S.WrChooseCate
              style={{ display: "inline-block", width: "calc(50% - 15px)" }}
            >
              <Form.Item
                name="category"
                label="Choose category"
                rules={[{ required: true, message: "This field is require" }]}
              >
                <SelectCmp
                  // defaultValue="inactive"
                  style={{
                    width: "100%",
                    height: 48,
                  }}
                  options={categories}
                  placeholder="Choose category"
                />
              </Form.Item>
              <S.AddCate onClick={() => setIsOpenModal(true)}>
                Add category
              </S.AddCate>
            </S.WrChooseCate> */}
            <Form.Item
              name="status"
              label="공개여부"
              style={{
                display: "inline-block",
                width: "calc(50% - 15px)",
                margin: "0 0 0 30px",
              }}
            >
              <Radio.Group size="large">
                {statusOptions?.map((item, index) => (
                  <Radio key={index} value={item.value}>
                    {item.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Form.Item>
        </S.Block>
        <S.Block>
          <Form.Item
            name="title"
            label="제목"
            rules={[
              { required: true, message: "This field is require" },
              {
                min: 3,
                message: "세글자 이상 입력해 주세요",
              },
            ]}
          >
            <CsInput
              // defaultValue="inactive"
              style={{
                width: "100%",
                height: 48,
              }}
              placeholder="Enter title"
              onChange={(e) => setTextSearch(e.target.value)}
              onBlur={(e) =>
                form.setFieldsValue({
                  title: e.target.value.trim().replace(/\s+/g, " "),
                })
              }
            />
          </Form.Item>
          <Form.Item
            name="description"
            label="내용"
            rules={[
              {
                validator: () => {
                  if (lenghtDes === 0) {
                    return Promise.reject("This field is required!");
                  } else if (lenghtDes < 3) {
                    return Promise.reject("세글자 이상 입력해 주세요");
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Editor
              data={form.getFieldValue("description")}
              onChangeValue={(e, editor) => handleChangeContent(e, editor)}
            />
          </Form.Item>
          {/* <Form.Item name="hashtag" label="Hashtag">
            <HashTagInput
              tags={form.getFieldValue("hashtag")}
              onTagsChange={handleTagsChange}
            />
          </Form.Item> */}
        </S.Block>
        <Form.Item className="group-btn">
          <Button
            onClick={onReset}
            htmlType="submit"
            className="btn btn-cancel"
            icon={<Close />}
          >
            Cancel
          </Button>
          {loading ? (
            <Button
              style={{
                width: "220px",
                height: "52px",
                backgroundColor: "#526557",
              }}
            >
              <LoadingOutlined />
            </Button>
          ) : (
            <Button
              onClick={onFill}
              htmlType="submit"
              className="btn btn-create"
              icon={<FilePlus />}
            >
              Create
            </Button>
          )}
        </Form.Item>
      </Form>
      <Modal
        title="Create category"
        open={isOpenModal}
        onCancel={() => setIsOpenModal(false)}
        footer={false}
      >
        <S.ModalContent>
          <Form
            name="createType"
            onFinish={handleCreateCategory}
            autoComplete="off"
            form={formCreateType}
          >
            <Form.Item
              name="typeName"
              rules={[{ required: true, message: "This field is require" }]}
            >
              <CsInput
                style={{ height: "48px" }}
                placeholder="Enter category name"
              />
            </Form.Item>
            <S.ModalBtn>
              <Button
                htmlType="button"
                onClick={() => setIsOpenModal(false)}
                className="cancel-btn"
              >
                Cancel
              </Button>
              <Button htmlType="submit" className="create-btn">
                Create
              </Button>
            </S.ModalBtn>
          </Form>
        </S.ModalContent>
      </Modal>
    </S.Wrapper>
  );
};

export default AnnouncementCreate;
